import { Checkbox } from "../ui/checkbox";

const link = (href, label, testId) => (
  <a href={href} target="_blank" rel="noreferrer" data-testid={testId} className="font-semibold text-orange-400 underline-offset-2 hover:underline">{label}</a>
);

export const AcceptTerms = ({ prefix, checked, onChange }) => (
  <label className="flex cursor-pointer items-start gap-3 border border-white/10 bg-[#0B1120] p-4 text-sm leading-relaxed text-slate-300 md:col-span-2">
    <Checkbox data-testid={`${prefix}-accept-terms`} checked={checked} onCheckedChange={(v) => onChange(v === true)}
      className="mt-0.5 rounded-none border-slate-500 data-[state=checked]:border-orange-500 data-[state=checked]:bg-orange-500" />
    <span>
      I accept the {link("/disclaimer", "Legal Disclaimer", `${prefix}-link-disclaimer`)}, {link("/terms", "Terms of Service", `${prefix}-link-terms`)} and{" "}
      {link("/privacy", "Privacy Policy", `${prefix}-link-privacy`)}, and confirm the details and documents I have given are true.
    </span>
  </label>
);
